"use client";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@watt/ui/components/ui/form";
import { Input } from "@watt/ui/components/ui/input";
import { Switch } from "@watt/ui/components/ui/switch";
import { useFormContext, useWatch } from "react-hook-form";
import type { ToastTesterConfig } from "./toast-tester-config";

type ToastTesterSwitchFieldProps = {
  switchName: "withAction" | "withCancel";
  labelName: "actionLabel" | "cancelLabel";
  switchLabel: string;
};

/**
 * A toggle for an optional toast button with an input for the button's label,
 * which is only editable while the toggle is on.
 */
export function ToastTesterSwitchField({
  switchName,
  labelName,
  switchLabel
}: ToastTesterSwitchFieldProps) {
  const { control } = useFormContext<ToastTesterConfig>();
  const isEnabled = useWatch({ control, name: switchName });

  return (
    <div className="space-y-1.5">
      <FormField
        control={control}
        name={switchName}
        render={({ field }) => (
          <FormItem className="flex items-center justify-between gap-3 space-y-0">
            <FormLabel className="text-xs">{switchLabel}</FormLabel>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
                size="sm"
              />
            </FormControl>
          </FormItem>
        )}
      />
      {isEnabled && (
        <FormField
          control={control}
          name={labelName}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  aria-label={`${switchLabel} label`}
                  className="h-8"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
}
